import { useState } from 'react';
import { MetabaseProvider, EditableDashboard } from "@metabase/embedding-sdk-react";
import { authConfig, METABASE_CONFIG } from '../config/metabaseConfig';
import './MetabaseAnalytics.css';

/**
 * MetabaseAnalytics Component
 * Embeds a Metabase dashboard using the Metabase Embedding SDK
 *
 * Features:
 * - Fully editable/interactive dashboard with drill-downs and filters
 * - Parameter controls for filtering data
 * - Click behaviors and question exploration
 * - Responsive layout
 */
const MetabaseAnalytics = () => {
  // Extract numeric ID from dashboard identifier if it's a string like "10-titan-dev"
  const getDashboardId = (id) => {
    if (typeof id === 'string') {
      const numericId = parseInt(id.split('-')[0], 10);
      return isNaN(numericId) ? id : numericId;
    }
    return id;
  };

  const dashboardId = getDashboardId(METABASE_CONFIG.dashboardId);

  // State for dashboard parameters (optional - you can pass initial filters here)
  const [parameters, setParameters] = useState({});

  return (
    <div className="metabase-analytics-container">
      <div className="metabase-dashboard-wrapper">
        <MetabaseProvider authConfig={authConfig}>
          <EditableDashboard
            dashboardId={dashboardId}
            initialParameters={parameters}
            withTitle={false}
            withDownloads={true}
            onParametersChange={(newParameters) => {
              console.log('Dashboard parameters changed:', newParameters);
              setParameters(newParameters);
            }}
          />
        </MetabaseProvider>
      </div>
    </div>
  );
};

export default MetabaseAnalytics;
